import { AxiosResponse } from 'axios'
import { HttpClient } from '@opallabs/api'

type MomentsFetcher = (arg: Record<string, any>) => Promise<AxiosResponse>

export const fetchMoments: MomentsFetcher = (getParams) =>
  HttpClient().get('/moments/v2', { params: getParams })
